import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CartPageState {
    isCartOpen: boolean;
}

const initialState: CartPageState = {
    isCartOpen: false,
};

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        setCartOpen: (state, action: PayloadAction<boolean>) => {
            state.isCartOpen = action.payload;
        },
        toggleCartOpen: (state) => {
            state.isCartOpen = !state.isCartOpen;
        },
    },
});

export const cartReducer = cartSlice.reducer;
export const { setCartOpen, toggleCartOpen } = cartSlice.actions;
